export default __webpack_public_path__ + "static/media/vk.d929ea98.svg";